import { render, staticRenderFns } from "./recommendedcourses.vue?vue&type=template&id=0df6e15a&scoped=true"
import script from "./recommendedcourses.vue?vue&type=script&lang=js"
export * from "./recommendedcourses.vue?vue&type=script&lang=js"
import style0 from "./recommendedcourses.vue?vue&type=style&index=0&id=0df6e15a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df6e15a",
  null
  
)

export default component.exports